import { render, staticRenderFns } from "./MemberInvite.vue?vue&type=template&id=228be1dc"
import script from "./MemberInvite.vue?vue&type=script&lang=js"
export * from "./MemberInvite.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports